import React from "react";

const ViewMore = () => {
  return (
    <p className="cursor-pointer font-pop text-sm font-normal text-primary">
      View more
    </p>
  );
};

export default ViewMore;
